<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      销售漏斗
    </p>
    <div class="search">
      <!-- 详细筛选条件 -->
      <div>
        <div
          class="search-detail"
          :class="{'search-detail-close': !searchVisible}"
          :style="{overflow: !searchVisible ? 'hidden' : ''}"
        >
        <div class="search-detail-item">
          <DateRangePicker
            class="search-input"
            placement="bottom-start"
            :placeholder="'跟进时间'"
            :value="emptyDate"
            @on-change="daterangeChange($event, 'start_create_time', 'end_create_time')"
          />
        </div>

        <div class="search-detail-item">
          <Select
            clearable
            filterable
            class="search-input"
            placeholder="请选择销售人员"
            element-id="custom_service_id"
            v-model="searchForm.custom_service_id"
          >
            <Option
              v-for="servicePeople in customServiceData"
              :key="servicePeople.id"
              :value="servicePeople.id+''"
            >{{servicePeople.name}}</Option>
          </Select>
        </div>

        <div class="search-detail-item">
          <Button
            type="primary"
            class="search-button"
            @click="loadList()"
          >查找</Button>
          <Button
            class="search-button"
            @click="resetSearchForm()"
          >重置</Button>
        </div>
        </div>
      </div>
    </div>

    <div class="page-dataReport">
      <div class="page-dataReport-left">
        <Card
          bordered
          class="smy__card-full"
          >
          <!-- 工单列表 -->
          <div class="table">
            <Table
              ref="table"
              :loading="listLoading"
              :columns="columns"
              :data="saleList"
            ></Table>
          </div>
        </Card>
      </div>

      <div class="page-dataReport-right">
        <Card
          bordered
          class="smy__card-full"
          >
          <div v-if="data.length > 0">
            <v-chart :force-fit="true" :height="height" :padding="[ 20, 120, 95 ]" :data="data" :scale="scale">
              <v-tooltip :show-title="false" :item-tpl="tooltipOpts.itemTpl" />
              <v-legend />
              <v-coord type="rect" direction="LT" />
              <v-pyramid :position="funnelOpts.position" :color="funnelOpts.color" :label="funnelOpts.label" :tooltip="funnelOpts.tooltip" />
              <v-guide v-for="(obj, index) in data"
                :key="index"
                type="text"
                :top="true"
                :position="getPosition(obj)"
                :content="getContent(obj)"
                :vStyle="{
                  fill: '#fff',
                  fontSize: '12',
                  textAlign: 'center',
                  shadowBlur: 2,
                  shadowColor: 'rgba(0, 0, 0, .45)'
                }"
              />
            </v-chart>
          </div>
        </Card>
      </div>
    </div>
    
  </Card>
 </div>
</template>

<script>
import { mapState } from 'vuex'
import DateRangePicker from '@/components/DateRangePicker'

const DataSet = require('@antv/data-set')

export default {
  components: {
    DateRangePicker
  },
  data () {
    return {
      emptyDate: ['', ''],
      searchVisible: true, // 是否显示详细筛选条件
      listLoading: false, // 表格加载状态
      customServiceData: '',
      searchForm: {
        custom_service_id: '', // 销售人员id
        end_create_time: '', // 跟进开始时间
        create_end_time: '' // 跟进结束时间
      },
      data: [],
      scale: {
        dataKey: 'percent',
        nice: false
      },
      height: 400,
      tooltipOpts: {
        showTitle: false,
        itemTpl: '<li data-index={index} style="margin-bottom:4px;">' +
        '<span style="background-color:{color};" class="g2-tooltip-marker"></span>' +
        '{name}<br/>' +
        '<span style="padding-left: 16px">企业数：{pv}</span><br/>' +
        '<span style="padding-left: 16px">占比：{percent}</span><br/>' +
        '</li>'
      },
      funnelOpts: {
        position: 'action*percent',
        color: ['action', ['#0050B3', '#1890FF', '#40A9FF', '#69C0FF', '#BAE7FF']],
        label: ['action*pv', (action, pv) => {
          return action + ' ' + pv
        }, {
          offset: 35,
          labelLine: {
            lineWidth: 1,
            stroke: 'rgba(0, 0, 0, 0.15)'
          }
        }],
        tooltip: ['action*pv*percent', (action, pv, percent) => ({
          name: action,
          percent: Math.floor(percent * 100) + '%',
          pv: pv
        })]
      },
      saleList: [
        { name: '开通', count: 0 },
        { name: '试用开通', count: 0 },
        { name: '部署测试', count: 0 },
        { name: '管理推广', count: 0 },
        { name: '商务协商', count: 0 },
        { name: '款项到账', count: 0 }
      ]
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '跟进节点',
          key: 'name',
          align: 'center'
        },
        {
          title: '企业数',
          key: 'count',
          align: 'center'
        }
      ]
      return allColumns
    }
  },
  watch: {
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/enterprise/saleFunnel/count', {
          params: {
            ...this.searchForm
          }
        })
      ]).then(this.$http.spread((res) => {
        if (res.success) {
          this.saleList[0].count = res.data.type0
          this.saleList[1].count = res.data.type1
          this.saleList[2].count = res.data.type2
          this.saleList[3].count = res.data.type3
          this.saleList[4].count = res.data.type4
          this.saleList[5].count = res.data.type5
          const rdata = this.saleList.map(item => {
            return {action: item.name, pv: item.count}
          })
          const dv = new DataSet.View().source(rdata)
          dv.transform({
            type: 'percent',
            field: 'pv',
            dimension: 'action',
            as: 'percent'
          })
          this.data = dv.rows
          this.listLoading = false
        }
      }))
    },
    // 日期 改变回调
    daterangeChange (daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0].replace('/', '-').replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyDate = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm () {
      this.emptyDate = ['', '']
      this.searchForm = {
        custom_service_id: '', // 销售人员id
        end_create_time: '', // 跟进开始时间
        create_end_time: '' // 跟进结束时间
      }
      this.loadList()
    },
    getPosition (obj) {
      return {
        action: obj.action,
        percent: 'median'
      }
    },
    getContent (obj) {
      return parseInt(String(obj.percent * 100)) + '%'
    }
  },
  created () {
    this.$http.get('/user/listBySysrole?sysrole=8').then(res => {
      this.customServiceData = res.data
    })
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 20px;
  .search-detail {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    height: 45px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}

.page-dataReport {
  display:flex;

  .page-dataReport-left {
    width:50%;
    margin-right:10px;
  }

  .page-dataReport-right {
    width:50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/salestatus/salefunnel/index.vue